import { type AxiosResponse, HttpStatusCode } from 'axios';
import { client } from '@/api/http';
import type { SurgeonOption } from '@/api/caseSettings';

interface ApiSurgeonsObject {
    surgeons: SurgeonOption[];
}

/**
 * The surgeons the signed-in user may act for.
 *
 * Self-scoped by design: the server answers for the caller and there is no way to ask which
 * surgeons somebody else can see. It is the same set that fills the case-settings dropdown, so
 * a surgeon offered here is one whose preferences the caller may also edit.
 */
export async function loadMySurgeons(): Promise<SurgeonOption[]> {
    const { status, data }: AxiosResponse<ApiSurgeonsObject> = await client.get(
        '/users/me/surgeons',
    );

    if (status !== HttpStatusCode.Ok) {
        throw new Error('Failed to load the surgeons available to you');
    }

    return data.surgeons ?? [];
}
